// src/axios.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,             // stuurt cookies automatisch mee
  xsrfCookieName: 'csrf_access_token',
  xsrfHeaderName: 'X-CSRF-TOKEN',
});

const api_noIntercept = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true
});

// Voeg request-interceptor toe die de X-CSRF-TOKEN header automatisch zet
api.interceptors.request.use(config => {
  // Lees de CSRF-token uit de cookies
  const getCookie = (name) =>
    document.cookie.split('; ').reduce((r, v) => {
      const [key, val] = v.split('=');
      return key === name ? decodeURIComponent(val) : r
    }, '');

  // Voor de refresh endpoint gebruiken we de refresh-CSRF, anders de access-CSRF
  const csrfToken = config.url.endsWith('/auth/refresh')
    ? getCookie('csrf_refresh_token')
    : getCookie('csrf_access_token');

  if (csrfToken) {
    config.headers['X-CSRF-TOKEN'] = csrfToken;
  }
  return config;
});

export { api, api_noIntercept };
export default api;
